import React, {useEffect, useRef} from 'react';
import {useField} from '@unform/core';
import InputMask from 'react-input-mask';

const ReactInputCpfCnpj = (props) => {
    const {
        name,
        type,
        label,
        disabled,
        id,
    } = props;
    const inputRef = useRef(null);
    const {fieldName, defaultValue, registerField, error} = useField(name);
    const lastTypeRef = useRef(null);

    useEffect(() => {
        registerField({
            name: fieldName,
            ref: inputRef.current,
            path: 'value',
        });
    }, [registerField, fieldName]);

    useEffect(() => {
        if (type) {
            lastTypeRef.current = type;
        }
    }, [type]);

    return (
        <>
            {label && <label htmlFor={fieldName}>{label}</label>}

            <InputMask
                ref={inputRef}
                name={name}
                id={id}
                disabled={disabled}
                className={'form-control'}
                mask={(type ?? lastTypeRef.current) === 'cpf' ? '999.999.999-99' : '99.999.999/9999-99'}
                defaultValue={defaultValue}
            />

            {error && <span>{error}</span>}
        </>
    );
};

export default ReactInputCpfCnpj;
